import React, { Component } from "react";
import moment from "moment";
import Helmet from "react-helmet";
import DayPicker from "react-day-picker";
import "react-day-picker/lib/style.css";
import { connect } from "react-redux";
import { setSelectedDays, setDayRange } from "../redux/actions";
import { selectSelectedDays, selectWeekCount } from "../redux/selectors";
function getWeekDays(weekStart, weekCount) {
    const days = [weekStart];
    for (let i = 1; i < weekCount * 7; i += 1) {
        days.push(
            moment(weekStart)
                .add(i, "days")
                .toDate()
        );
    }
    return days;
}

function getWeekRange(date) {
    return {
        from: moment(date)
            .startOf("isoWeek")
            .toDate(),
        to: moment(date)
            .endOf("isoWeek")
            .toDate()
    };
}

class DatePicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hoverRange: undefined
        };
    }

    handleDayChange = date => {
        const selectedDays = getWeekDays(
            getWeekRange(date).from,
            this.props.weekCount
        );
        this.props.setSelectedDays(
            getWeekDays(getWeekRange(date).from, this.props.weekCount)
        );
        this.props.setDayRange(
            selectedDays[0],
            selectedDays[this.props.weekCount * 7 - 1]
        );
    };

    handleDayEnter = date => {
        this.setState({
            hoverRange: getWeekRange(date)
        });
    };

    handleDayLeave = () => {
        this.setState({
            hoverRange: undefined
        });
    };

    handleWeekClick = (weekNumber, days, e) => {
        this.setState({
            selectedDays: days
        });
    };

    render() {
        const { hoverRange } = this.state;
        const selectedDays = this.props.selectedDays;
        if (selectedDays === false) {
            return null;
        }
        const daysAreSelected = selectedDays.length > 0;

        const modifiers = {
            hoverRange,
            selectedRange: daysAreSelected && {
                from: selectedDays[0],
                to: selectedDays[this.props.weekCount * 7 - 1]
            },
            hoverRangeStart: hoverRange && hoverRange.from,
            hoverRangeEnd: hoverRange && hoverRange.to,
            selectedRangeStart: daysAreSelected && selectedDays[0],
            selectedRangeEnd:
                daysAreSelected && selectedDays[this.props.weekCount * 7 - 1]
        };
        const firstDayOfWeek = {
            "en-gb": 1
        };

        return (
            <div className="SelectedWeekExample">
                <DayPicker
                    selectedDays={selectedDays}
                    showWeekNumbers
                    showOutsideDays
                    modifiers={modifiers}
                    onDayClick={this.handleDayChange}
                    onDayMouseEnter={this.handleDayEnter}
                    onDayMouseLeave={this.handleDayLeave}
                    onWeekClick={this.handleWeekClick}
                    firstDayOfWeek={firstDayOfWeek["en-gb"]}
                />

                <Helmet>
                    <style>{`

                .DayPicker {
                    display:inline-block;
                    margin-left: -14px;
                }
                .SelectedWeekExample .DayPicker-Month {
                  border-collapse: separate;
                }
                .SelectedWeekExample .DayPicker-WeekNumber {
                  outline: none;
                }
                .SelectedWeekExample .DayPicker-Day {
                  outline: none;
                  border: 1px solid transparent;
                  padding: 0px;
                }
                .SelectedWeekExample .DayPicker-Day--hoverRange {
                  background-color: #EFEFEF !important;
                }
    
                .SelectedWeekExample .DayPicker-Day--selectedRange {
                  background-color: #fff7ba !important;
                  border-top-color: #FFEB3B;
                  border-bottom-color: #FFEB3B;
                  border-left-color: #fff7ba;
                  border-right-color: #fff7ba;
                }
    
                .SelectedWeekExample .DayPicker-Day--selectedRangeStart {
                  background-color: #FFEB3B !important;
                  border-left: 1px solid #FFEB3B;
                }
    
                .SelectedWeekExample .DayPicker-Day--selectedRangeEnd {
                  background-color: #FFEB3B !important;
                  border-right: 1px solid #FFEB3B;
                }
    
                .SelectedWeekExample .DayPicker-Day--selectedRange:not(.DayPicker-Day--outside).DayPicker-Day--selected,
                .SelectedWeekExample .DayPicker-Day--hoverRange:not(.DayPicker-Day--outside).DayPicker-Day--selected {
                  border-radius: 0 !important;
                  color: black !important;
                }
                .SelectedWeekExample .DayPicker-Day--hoverRange:hover {
                  border-radius: 0 !important;
                }
              `}</style>
                </Helmet>
            </div>
        );
    }
}
export default connect(
    store => {
        return {
            selectedDays: selectSelectedDays(store),
            weekCount: selectWeekCount(store)
        };
    },
    { setSelectedDays, setDayRange }
)(DatePicker);
